// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"2919": "7a72be63","4156": "e1b0488e","6415": "6c46a307",}[chunkId] + ".css"
}